import { MARQUEE_TEXT } from "../data/site";

const Row = () => (
  <span className="font-syncopate font-bold uppercase text-2xl md:text-4xl tracking-tight text-white whitespace-nowrap pr-2">
    {MARQUEE_TEXT.repeat(3)}
  </span>
);

export const Marquee = () => (
  <div
    data-testid="text-marquee"
    aria-hidden="true"
    className="relative border-y border-[#222] bg-black py-5 md:py-7 overflow-hidden select-none"
  >
    <div className="animate-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
